import styled from "styled-components";

export const ManageMyBookingSectionTitleBox = styled.div`
    font-size: ${props => props.theme.fontSize.h2};
    font-weight: ${props => props.theme.fontWeight.semiBold};
`


